export default "__VITE_ASSET__590e3d37__"